const statisticsPl = {
    "user_statistics": "Statystyki użytkownika",
    "menu_item_clicks": "Kliknięcia elementów menu",
    "statistics": "Statystyka",
    "user_traffic": "Ruch użytkowników",
    "last_7_days": "Ostatnie 7 dni",
    "last_30_days": "Ostatnie 30 dni",
    "menu_item": "Pozycja menu",
    "click_count": "Liczba kliknięć",
    "error_fetching_user_statistics": "Błąd podczas pobierania statystyk użytkownika.",
    "error_fetching_menu_item_statistics": "Błąd podczas pobierania statystyk pozycji menu.",
    "statistics_feature_not_available": "Funkcja statystyk jest dostępna tylko w planie PRO. Aby uzyskać dostęp do tej funkcji, należy uaktualnić subskrypcję.",
    "change_subscription_plan": "Zmień plan subskrypcji",
    "permission_denied": "Odmowa pozwolenia",
    "error_fetching_rating_statistics": "Błąd podczas pobierania statystyk ocen.",
    "menu_item_ratings": "Oceny pozycji menu",
    "likes": "upodobania",
    "dislikes": "nie lubi",
    "rating_trends_last_7_days": "Trendy ocen (ostatnie 7 dni)",
    "rating_trends_last_30_days": "Trendy ocen (ostatnie 30 dni)",
    "kpi_total_visitors": "Łączna liczba odwiedzin",
    "kpi_avg_per_day": "Śred. / dzień",
    "kpi_peak_day": "Szczytowy dzień",
    "kpi_top_item": "Najczęściej klikane",
    "kpi_clicks": "kliknięć",
    "kpi_vs_prev": "vs poprzedni okres",
    "current_period": "Bieżący okres",
    "previous_period": "Poprzedni okres",
    "visitors": "odwiedzających",
    "hourly_traffic": "Ruch godzinowy",
    "utm_sources": "Źródła ruchu",
    "utm_unknown": "Nieznany",
    "no_data": "Brak danych",
};

export default statisticsPl;
